// removed by extract-text-webpack-plugin
module.exports = {"icon":"AddFilterBox__icon___1eh0P","addText":"AddFilterBox__addText___2C2m9","addFilterContainer":"AddFilterBox__addFilterContainer___2YRz6","addIcon":"AddFilterBox__addIcon___2BzUQ"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/companies/components/advancedSearch/AddFilterBox.scss
// module id = 1671
// module chunks = 0